import { render, staticRenderFns } from "./RestoreStorePopup.vue?vue&type=template&id=32517212&scoped=true&"
import script from "./RestoreStorePopup.vue?vue&type=script&lang=ts&"
export * from "./RestoreStorePopup.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreStorePopup.vue?vue&type=style&index=0&id=32517212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32517212",
  null
  
)

export default component.exports